/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type StepRecipeModal_allWarnings$ref: FragmentReference;
declare export opaque type StepRecipeModal_allWarnings$fragmentType: StepRecipeModal_allWarnings$ref;
export type StepRecipeModal_allWarnings = {|
  +edges: $ReadOnlyArray<?{|
    +node: ?{|
      +id: string,
      +slugName: string,
    |}
  |}>,
  +$refType: StepRecipeModal_allWarnings$ref,
|};
export type StepRecipeModal_allWarnings$data = StepRecipeModal_allWarnings;
export type StepRecipeModal_allWarnings$key = {
  +$data?: StepRecipeModal_allWarnings$data,
  +$fragmentRefs: StepRecipeModal_allWarnings$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StepRecipeModal_allWarnings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "WarningNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WarningNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slugName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WarningNodeConnection"
};
// prettier-ignore
(node/*: any*/).hash = '1d07de1934718759f5bd4bdb76ac2471';

module.exports = node;
